import RegistrationForm from '../components/forms/RegistrationForm';
import {openLoginModal} from '../components/commonFunctions';

class UserRegistrationPage {
	constructor() {
		this.initRegistrationForm();
		this.initCatchOpenLoginForm();
	}
	
	initRegistrationForm() {
		const registrationForm = document.querySelector('.registrationForm'),
			  afterRegistrationElement = document.querySelector('.afterRegistration'),
			  emailInput = registrationForm.querySelector('input[name="email"]');
		
		new RegistrationForm(
			registrationForm,
			{
				'onSuccess': () => {
					afterRegistrationElement.querySelector('#afterRegistration-email').textContent = emailInput.value;
					registrationForm.classList.add('d-none');
					afterRegistrationElement.classList.remove('d-none');
				}
			}
		);
	}
	
	initCatchOpenLoginForm() {
		$('.registrationForm .switchToTheLoginForm').on('click', openLoginModal);
	}
}

new UserRegistrationPage();